export async function fetchReply (history: any[], text: string, job: string, experience: string, name: string): Promise<string> {
  const historyEncoded = encodeURIComponent(history.join('\n'))
  const textEncoded = encodeURIComponent(text)
  const url = `/api?eval=false&text=${textEncoded}&history=${historyEncoded}&job=${job}&experience=${experience}&name=${name}`

  const response = await fetch(url)
  const reply = await response.text()

  return reply
}
export async function fetchEval (history: any[], text: string, loggingMetrics: any): Promise<string> {
  const transcriptionEncoded = encodeURIComponent(history.join('\n'))
  const textEncoded = encodeURIComponent(text)
  const url = `/api?eval=true&text=${textEncoded}&transcription=${transcriptionEncoded}&loggingMetrics=${JSON.stringify(loggingMetrics)}`

  const response = await fetch(url)
  const reply = await response.text()

  return reply
}
